// Recovery keeps a bounded, evenly spaced copy of the BPM samples. Its cadence
// can be much slower than the live sensor's; a fixed 30-second limit would turn
// an otherwise continuous recovered recording into isolated strokes.
export function heartRateContinuityGapMs(timestamps) {
  const intervals = [];
  for (let index = 1; index < timestamps.length; index += 1) {
    const gap = Number(timestamps[index]) - Number(timestamps[index - 1]);
    if (Number.isFinite(gap) && gap > 0 && gap <= 180000) intervals.push(gap);
  }
  intervals.sort((a, b) => a - b);
  // After a WebView restart, up to 900 evenly spaced recovery samples are
  // followed by dense live samples. The median then reflects only the live
  // burst and incorrectly splits every recovered point into an isolated mark.
  // The upper quartile retains the recovered cadence while the three-interval
  // limit still leaves genuine multi-minute outages visible.
  const cadence = intervals.length
    ? intervals[Math.floor((intervals.length - 1) * 0.75)]
    : 1000;
  return Math.min(180000, Math.max(8000, cadence * 3));
}

export function heartRateLinkGapMs(previous, current, ordinaryGapMs) {
  // A recovered/compacted point represents a longer interval of the same
  // recording; do not mistake that deliberate thinning for a sensor outage.
  return previous?.sparse || current?.sparse
    ? Math.max(ordinaryGapMs, 120000)
    : ordinaryGapMs;
}
